export const matchingCandidateSelector = state => state.matchingCandidateInfo;